import AdminCrud from "@/components/admin/AdminCrud";

// Icon choices exposed to admin; keys must match ICONS map in /pages/Services.js
const ICON_OPTIONS = [
  { value: "route", label: "Route" },
  { value: "plane", label: "Plane" },
  { value: "building", label: "Building" },
  { value: "building-2", label: "Building (variant)" },
  { value: "heart", label: "Heart" },
  { value: "mountain", label: "Mountain" },
  { value: "users", label: "Users" },
  { value: "landmark", label: "Landmark" },
  { value: "sparkles", label: "Sparkles" },
  { value: "car", label: "Car" },
  { value: "bus", label: "Bus" },
  { value: "map-pin", label: "Map pin" },
  { value: "compass", label: "Compass" },
  { value: "shield-check", label: "Shield" },
  { value: "clock-3", label: "Clock" },
  { value: "star", label: "Star" },
];

export default function AdminServices() {
  return (
    <AdminCrud
      title="Services"
      resource="services"
      defaultItem={{
        title: "", slug: "", tagline: "", body: "", icon: "sparkles",
        image_url: "", features: [], order: 1,
      }}
      fields={[
        { key: "title", label: "Service title" },
        { key: "slug", label: "Slug (URL fragment)" },
        { key: "tagline", label: "Tagline (short kicker above title)" },
        { key: "body", label: "Description", type: "textarea", rows: 4 },
        { key: "icon", label: "Icon", type: "select", options: ICON_OPTIONS },
        { key: "image_url", label: "Cover image", type: "image" },
        { key: "features", label: "Features (one per line)", type: "list" },
        { key: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
